<div class="location">
  <div>{{location.slicName}}</div>
  <div><a href="" [class.filtered]="isCustomSorted" (click)="filterByLocation($event)">{{location.users}}</a> {{localize(langSection.LocationUserPage, langText.Users)}}</div>
  <div title="{{location.customName}}">{{location.customName}}</div>
  <div><a href="" (click)="openCustomNameModal($event)">{{localize(langSection.LocationUserPage, langText.Edit)}}</a></div>
  <div title="{{location.address | replace: emptyAddressRegex}}">{{location.address | replace: emptyAddressRegex}}</div>
</div>
